import React from 'react';
import Select from 'react-select';
import i18n from 'i18n-js';

import CommonInputValidation from '../../Container/ComomInputValidation'

const FormPaymentAddressInfo = (props: any) => {
  const { changeCheckoutForm, checkoutIndex, setStateValue, solutionValue, form, submitBooking, userBookingInformation, dogsList, dogArr, dogCount } = props;
  const cssWrapper = checkoutIndex === 1 ? 'box-wrapper show' : 'box-wrapper hide';


  let dogs = [];
  let ableToAddMoreDog = true;

  for(let x=0; x < userBookingInformation.solutions.length; x++) {
    if (userBookingInformation.solutions[x].uid === solutionValue && !userBookingInformation.solutions[x].ableToAddMoreDog) {
      ableToAddMoreDog = false;
    }
  }

  for(let x = 0; x < dogArr.length; x++) {
    let temp: any = {
      value: dogArr[x].value,
      label: dogArr[x].label,
    };

    if (form.dogsValue.value && !ableToAddMoreDog) {
      temp = {
        value: dogArr[x].value,
        label: dogArr[x].label,
        isDisabled: true,
      }
    }

    dogs.push(temp);
  }

  return (
    <div className="form-payment-address-info box-form">
      <p onClick={() => changeCheckoutForm(1)} className="sub-title">{i18n.t('paymentAddress')}</p>
      <div className={cssWrapper}>
        <div className="box-input-field">
          <CommonInputValidation
            label={i18n.t('firstName')}
            name="firstName"
            required={true}
            value={userBookingInformation.owner.firstName}
            setStateValue={setStateValue}
            form={form}
          />
        </div>
        <div className="box-input-field">
          <CommonInputValidation
            label={i18n.t('middleName')}
            name="middleName"
            value={userBookingInformation.owner.middleName}
            setStateValue={setStateValue}
            form={form}
          />
        </div>
        <div className="box-input-field">
          <CommonInputValidation
            label={i18n.t('lastName')}
            name="lastName"
            value={userBookingInformation.owner.lastName}
            required={true}
            setStateValue={setStateValue}
            form={form}
          />
        </div>

        {
          // <div className="box-input-field">
          //   <CommonInputValidation
          //     label={i18n.t('street')}
          //     name="address"
          //     value={userBookingInformation.owner.address}
          //     required={true}
          //     setStateValue={setStateValue}
          //     form={form}
          //   />
          // </div>
          // <div className="box-input-field">
          //   <CommonInputValidation
          //     label={i18n.t('zipCode')}
          //     name="zip"
          //     value={userBookingInformation.owner.zip}
          //     required={true}
          //     setStateValue={setStateValue}
          //     form={form}
          //   />
          // </div>
          // <div className="box-input-field">
          //   <CommonInputValidation
          //     label={i18n.t('town')}
          //     name="city"
          //     value={userBookingInformation.owner.city}
          //     required={true}
          //     setStateValue={setStateValue}
          //     form={form}
          //   />
          // </div>
          // <div className="box-input-field">
          //   <p>{i18n.t('country')} <span className="require">*</span></p>
          //   <div className="box-dropdown">
          //     <select>
          //       <option value="0">Denmark</option>
          //     </select>
          //   </div>
          // </div>
        }
        <div className="box-input-field">
          <CommonInputValidation
            label={i18n.t('telephone')}
            name="telephone"
            value={userBookingInformation.owner.telephone}
            required={true}
            setStateValue={setStateValue}
            form={form}
          />
        </div>
        {
          // <div className="box-input-field">
          //   <p>{i18n.t('ChoosePaymentAddress')}</p>
          //   <div className="box-dropdown">
          //     <select>
          //       <option value="0">Denmark</option>
          //     </select>
          //   </div>
          // </div>
        }
        <div className="box-input-field">
          {
            // <CommonInputValidation
            //   label={i18n.t('selectYourDogFromList')}
            //   name="dogList"
            //   setStateValue={setStateValue}
            //   form={form}
            // />
          }
          <div className="box-input-validate">
            <p>{i18n.t('selectYourDogFromList')}</p>
            <Select
              value={form.dogsValue.value}
              onChange={(data: any) => {
                setStateValue(
                  {
                    form: Object.assign(form, {dogsValue: {
                      value: data && data.length ? data : null,
                      required: form.dogsValue.required,
                      errorMessage: '',
                      name: 'dogsValue'
                    }})
                  }
                )
              }}
              options={dogs}
              noOptionsMessage={() => i18n.t('noAvailable')}
              placeholder={i18n.t('chooseDog')}
              isMulti
            />
            {
              form && form.dogsValue && form.dogsValue.errorMessage ?
                <p className="require pd-top-5">{form.dogsValue.errorMessage}</p>
              : null
            }
          </div>
        </div>
        <div className="box-btn">
          <button className="red" onClick={() => submitBooking(2)}>
            {i18n.t('continue')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FormPaymentAddressInfo;
